import { render, staticRenderFns } from "./CarouselExpansionPanel.vue?vue&type=template&id=902dea5a&"
import script from "./CarouselExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./CarouselExpansionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports